import { type Meta } from '../types/docs';
import {
  AUTOMATIONS_ANALYTICS_CATEGORY_META_PARAM,
  AUTOMATIONS_ANALYTICS_LIST_STATES,
  AUTOMATIONS_ANALYTICS_LIST_STATUSES,
  AUTOMATIONS_ANALYTICS_PAGES,
  AUTOMATIONS_ANALYTICS_PROMPT_MODES,
} from './automationsAnalytics';

const META: Meta = {
  description: 'The user views an automations surface (list, create, or detail)',
  name: 'automations_page_viewed',
  params: [
    AUTOMATIONS_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'Which automations page was viewed',
      name: 'page',
      required: true,
      type: 'enum',
      values: [...AUTOMATIONS_ANALYTICS_PAGES],
    },
    {
      description: 'Whether the list is empty or has automations (required when page is list)',
      name: 'list_state',
      required: false,
      type: 'enum',
      values: [...AUTOMATIONS_ANALYTICS_LIST_STATES],
    },
    {
      description: 'Number of automations on the list (sent when list_state is populated)',
      name: 'automation_count',
      required: false,
      type: 'number',
    },
    {
      description: 'The automation being viewed (required when page is detail)',
      name: 'automation_id',
      required: false,
      type: 'string',
    },
    {
      description: 'Whether the automation is enabled (required when page is detail)',
      name: 'enabled',
      required: false,
      type: 'boolean',
    },
    {
      description: 'Whether the automation uses a linked skill or a custom prompt (required when page is detail)',
      name: 'prompt_mode',
      required: false,
      type: 'enum',
      values: [...AUTOMATIONS_ANALYTICS_PROMPT_MODES],
    },
    {
      description: 'Aggregate status shown for the automation on the list (detail page only)',
      name: 'list_status',
      required: true,
      type: 'enum',
      values: [...AUTOMATIONS_ANALYTICS_LIST_STATUSES],
    },
  ],
};

export default META;
